import { render, staticRenderFns } from "./cooperation-detail.vue?vue&type=template&id=26766844&scoped=true&"
import script from "./cooperation-detail.vue?vue&type=script&lang=js&"
export * from "./cooperation-detail.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-detail.vue?vue&type=style&index=0&id=26766844&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26766844",
  null
  
)

export default component.exports